import {useContext, useEffect, useState} from "react";
import OwButton from "../../OwButton/OwButton";
import IQBPaymentCard from "../../../../models/IQBPaymentCard";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import UiContext from "../../../../contexts/UiContext";
import {SocketContext} from "../../../../contexts/SocketContext";
import IOnGetCardsDTO from "../../../../models/DTO/IOnGetCardsDTO";
import IOnDeleteACardDTO from "../../../../models/DTO/IOnDeleteACardDTO";
import IOnUpdateOrderCardToUseDTO from "../../../../models/DTO/IOnUpdateOrderCardToUseDTO";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import IOnGetCardDTO from "../../../../models/DTO/IOnGetCardDTO";
import IOnCreateCardFromTokenDTO from "../../../../models/DTO/IOnCreateCardFromTokenDTO";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IGetCardsDTO from "../../../../models/DTO/IGetCardsDTO";
import IGetCardDTO from "../../../../models/DTO/IGetCardDTO";
import IOrder from "../../../../models/IOrder";
import IDeleteACardDTO from "../../../../models/DTO/IDeleteACardDTO";
import IUpdateOrderCardToUseDTO from "../../../../models/DTO/IUpdateOrderCardToUseDTO";
import {QuickBooksPaymentExistingCards} from "../QuickBooksPaymentExistingCards/QuickBooksPaymentExistingCards";
import { LoadingResults } from "../../LoadingResults/LoadingResults";
import "./QuickBooksPaymentSetupDetail.scss";
import {QuickBooksPaymentNewCard} from "../QuickBooksPaymentNewCard/QuickBooksPaymentNewCard";
import IOrder_Progress_State from "../../../../models/IOrder_Progress_State";
import {QbPaymentContext} from "../../../../contexts/QbPaymentContext";

type Props = {
    orderModel: IOrder;
    nextStep?: IOrder_Progress_State;
};

export const QuickBooksPaymentSetupDetail = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;
    const qbPaymentContext = useContext(QbPaymentContext);

    const onGetCards = (data: IOnGetCardsDTO) => {
        setGetExistingCardsActive(false);
        setExistingCards(data.cards);
        qbPaymentContext.setIsLoading(false);

        if (!qbPaymentContext.existingCard) {
            const hasCards = !!data.cards.length;

            // setUseExistingCard(hasCards);
            setActiveBtn(hasCards? "existing" : "new");
        }
    }

    const onUpdateOrderCardToUse = (data: IOnUpdateOrderCardToUseDTO) => {
        const notification: INotification = {
            message: "successfully_updated_order_card_to_use",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        setDoneProcessing(true);
        setUpdatedCartToUse(true);
        qbPaymentContext.setIsLoading(false);
    };



    const sockets: IUiSocketSetup[] = [
        {endpoint: EndpointsEnum.PaymentsOnGetCards, fn: onGetCards},
        {endpoint: EndpointsEnum.OrderOnUpdateOrderCardToUse, fn: onUpdateOrderCardToUse},

    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getCards()

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        }
    }, []);


    const [existingCards, setExistingCards] = useState<IQBPaymentCard[]>();

    const [getExistingCardsActive, setGetExistingCardsActive] = useState(true);

    const [activeBtn, setActiveBtn] = useState<"existing" | "new" | "">("");

    const [cardSelected, setCardSelected] = useState(false);

    const [isProcessing, setIsProcessing] = useState(false);

    const [doneProcessing, setDoneProcessing] = useState(false);
    const [updatedCardToUse, setUpdatedCartToUse] = useState(false);

    const getCards = () => {
        const payload: IGetCardsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.orderModel.Vendor!.guid,
        };

        socket.emit(EndpointsEnum.PaymentsGetCards, payload);

        setGetExistingCardsActive(true);

        qbPaymentContext.setIsLoading(true);
    }



    const deleteExistingCard = () => {
        if (qbPaymentContext.existingCard) {
            const payload: IDeleteACardDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: props.orderModel.Vendor!.guid,
                card_id: qbPaymentContext.existingCard.id,
            };

            socket.emit(EndpointsEnum.PaymentsDeleteACard, payload);

            setIsProcessing(true);
        }
    };



    return <div className={"QuickBooksPaymentSetupDetail position-relative w-100 h-100 d-flex flex-column"}>
        <div className={"d-flex justify-content-center w-100"}>
            <div className={"text-center"}>
                <div className="btn-group">
                    {
                        existingCards?.length? <OwButton
                        title={"existing_card"}
                        className={"btn-primary " + (activeBtn === "existing"? "active" : "")}
                        fn={() => { setActiveBtn("existing") }}
                    /> : null }
                    <OwButton
                        title={"new_card"}
                        className={"btn-primary " + (activeBtn === "new"? "active" : "")}
                        fn={() => { setActiveBtn("new") }}
                    />
                </div>
            </div>

        </div>

        <div>
            {existingCards && activeBtn === "existing"? <QuickBooksPaymentExistingCards
                existingCards={existingCards}
                orderModel={props.orderModel}
                getExistingCardsActive={getExistingCardsActive}
                getCards={getCards}
            /> : null}
            {activeBtn === "new"? <QuickBooksPaymentNewCard nextStep={props.nextStep} orderModel={props.orderModel}/> : null}
        </div>
    </div>;
};
